var styleDataHash = '6c56334d';  
export const injectCss = (() => {
  var css = `.PBsHY,.glob_fontElementMap{font-family:var(--ricos-font-family,unset)}.a0sk6{border:1px solid rgba(var(--ricos-text-color-tuple,33,33,33),.4);box-shadow:0 0 10px 0 rgba(0,0,0,.06);position:fixed;z-index:11}.MB8EK{background-color:#fff;max-height:339px;max-width:360px}.MB8EK,._2ipWZ{display:flex;flex-direction:column}._2ipWZ{gap:4px;padding:16px}._4HnPV{color:var(--ricos-text-color-low,#646464);font-size:14px;line-height:20px}._5xCWy{font-size:16px;line-height:24px}.Yyv0-,._5xCWy{color:var(--ricos-text-color,#212121);display:-webkit-box;overflow:hidden;text-overflow:ellipsis;-webkit-line-clamp:2;-webkit-box-orient:vertical}.Yyv0-{font-size:14px;line-height:20px}.VV-WU{height:100%;width:100%}.EPkh-{height:190px;width:100%}`;
  var isTest = typeof process !== 'undefined' && process.env && process.env['NODE_ENV'] === 'test';

  if (isTest || !css || typeof document === 'undefined') { return; }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.setAttribute('data-ricos-style-hash', styleDataHash);
  style.type = 'text/css';

  head.appendChild(style);

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
});

injectCss();



export default {
  "fontElementMap": "PBsHY",
  "container": "a0sk6",
  "viewerContainer": "MB8EK",
  "texts": "_2ipWZ",
  "url": "_4HnPV",
  "title": "_5xCWy",
  "description": "Yyv0-",
  "Image": "VV-WU",
  "ImageWrapper": "EPkh-"
};